//----- Component --------------------------------------------------------/
// Developer : Daiana Curcio
// Creation Date : 14/07/2025
// Version : 1
// Description : Identifica la planta con mayor demanda.
//------Changes ----------------------------------------------------------//
// Change Date :
// Change by :
// Change description:
// Change Date :
// Change by :
// Change description:
//========================================================================/
import React, { useState, useEffect } from "react";
import {
  Typography,
  CircularProgress,
  Stack,
  Grid,
  Box,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
} from "@mui/material";
import { UrlApi } from "../../../services/apirest";
import VisibilityIcon from "@mui/icons-material/Visibility";
import moment from "moment";

function Planta_Mayor_Demanda() {
  const [plantas, setPlantas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [detalle, setDetalle] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [plantaSeleccionada, setPlantaSeleccionada] = useState(null);

  useEffect(() => {
  const obtenerPlantas = () => {
    setLoading(true);
    fetch(`${UrlApi}/estadisticas/plantaMayorDemanda`)
      .then((res) => res.json())
      .then((data) => setPlantas(data))
      .catch((error) => console.error("Error al obtener datos", error))
      .finally(() => setLoading(false));
  };

  obtenerPlantas(); // Carga inicial

  const intervalo = setInterval(() => {
    obtenerPlantas(); // Refresca periódicamente
  }, 10000 ); // 10 segundos

  return () => clearInterval(intervalo); // Limpieza al desmontar
}, []);


  if (loading) return <CircularProgress sx={{ mt: 2 }} />;

  if (plantas.length === 0) return null;

  const verDetalle = (id_sucursal, nombre) => {
    fetch(`${UrlApi}/estadisticas/detalleDemanda/${id_sucursal}`)
      .then((res) => res.json())
      .then((data) => {
        setDetalle(data);
        setPlantaSeleccionada(nombre);
        setOpenDialog(true);
      })
      .catch((error) => {
        console.error("Error al obtener detalle de la demanda", error);
      });
  };

  return (
  <div>
    <Grid container padding={3} spacing={2} alignItems="center">
      <Grid item xs={12}>
        <Typography
          variant="h6"
          sx={{
            fontWeight: "bold",
            fontSize: 20,
            flexGrow: 1,
            textAlign: "center",
          }}
        >
          Mayor demanda de insumos
        </Typography>

        {/* Spinner dentro del contenido */}
        {loading && (
          <Box display="flex" justifyContent="center" mt={2}>
            <CircularProgress />
          </Box>
        )}

        {/* Contenido solo si hay datos */}
        {!loading && plantas.length > 0 && (
          <Stack spacing={2} width="100%" mt={2}>
            {plantas.map((planta, index) => (
              <Box
                key={index}
                sx={{
                  backgroundColor: "#ffffff",
                  padding: 2,
                  borderRadius: 2,
                  border: "1px solid #ccc",
                  boxShadow: 1,
                }}
              >
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Box>
                    <Typography variant="subtitle1" fontWeight="bold">
                      • {planta.nombre_destino}
                    </Typography>
                    <Typography variant="body2">
                      Total recibido:{" "}
                      <strong style={{ color: "#2B76A6" }}>
                        {planta.total_recibido}
                      </strong>
                    </Typography>
                  </Box>
                  <IconButton
                    onClick={() =>
                      verDetalle(
                        planta.sucursal_destino,
                        planta.nombre_destino
                      )
                    }
                  >
                    <VisibilityIcon sx={{ color: "#2B76A6" }} />
                  </IconButton>
                </Box>
              </Box>
            ))}
          </Stack>
        )}
      </Grid>
    </Grid>

    {/* Dialog (sin cambios) */}
    <Dialog
      open={openDialog}
      onClose={() => setOpenDialog(false)}
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle
        sx={{
          backgroundColor: "#2B76A6",
          color: "white",
          fontWeight: "bold",
        }}
      >
        Detalle de artículos - {plantaSeleccionada}
      </DialogTitle>
      <DialogContent dividers>
        {detalle.length > 0 ? (
          <Grid container spacing={2}>
            {detalle.map((item, i) => (
              <Grid item xs={12} key={i}>
                <Box
                  sx={{
                    border: "1px solid #ddd",
                    p: 1,
                    borderRadius: 2,
                    backgroundColor: "#f9f9f9",
                  }}
                >
                  <Typography>
                    <strong>Artículo:</strong> {item.nombre_articulo}
                  </Typography>
                  <Typography>
                    <strong>Recibido:</strong> {item.cantidad_recibida}
                  </Typography>
                  <Typography>
                    <strong>Fecha:</strong>{" "}
                    {moment(item.fecha_transaccion).format("DD-MM-YYYY")}
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        ) : (
          <Typography>No hay datos.</Typography>
        )}
      </DialogContent>
    </Dialog>
  </div>
  );
}

export default Planta_Mayor_Demanda;
